<template>
  <div
    class="wg-row com-anm22-app-scrolling-panel"
    style="flex-wrap: nowrap; height: calc(100vh - 107px); padding: 10px"
  >
    <wg-modal
      v-if="showTagDialog"
      :portal="true"
      :width="'400px'"
      @closeModal="showTagDialog = false"
    >
      <div class="com-anm22-app-text-xl" slot="header">
        {{ $anm22.strLang(lang, "Tags", "Etichette") }}
      </div>
      <div slot="body" class="wg-row">
        <!-- Form di aggiunta -->
        <div class="wg-row" style="flex-wrap: nowrap">
          <div class="color-select">
            <div
              class="wg-row color-selected"
              @click="showColors = !showColors"
            >
              <div
                :style="{
                  height: '12px',
                  width: '12px',
                  borderRadius: '50%',
                  backgroundColor: newTag.color,
                }"
              ></div>
            </div>
            <div v-show="showColors" class="display-flex color-list">
              <div
                v-for="(color, index) in tagColors"
                :key="'color-' + index"
                class="wg-row"
                :title="color.name"
                @click="selectColor(color.color)"
              >
                <div :style="{ backgroundColor: color.color }"></div>
              </div>
            </div>
          </div>
          <input
            class="com-anm22-app-input-text"
            type="text"
            :placeholder="$anm22.strLang(lang, 'Label', 'Etichetta')"
            style="margin: 0 10px"
            v-model="newTag.label"
          />
          <input
            type="button"
            class="small"
            :style="{
              opacity: newTag.label === '' || canAddLabel == false ? '0.5' : '',
            }"
            :disabled="newTag.label === '' || canAddLabel == false"
            :value="$anm22.strLang(lang, 'Add', 'Aggiungi')"
            @click="addTag()"
          />
        </div>
        <div class="wg-row" style="margin-top:20px;justify-content:center;s">
          <input
            class="com-anm22-app-input-text"
            type="text"
            :placeholder="
              $anm22.strLang(lang, 'Tag name...', 'Nome etichetta...')
            "
            @input="tagSelectFilterString = $event.target.value"
          />
        </div>
        <!-- Lista -->
        <div class="wg-row com-anm22-app-scrolling-panel tags-list">
          <div
            v-for="(tag, index) in tagsToSelect"
            :key="'tag-' + index"
            class="wg-row tag-select"
          >
            <div class="display-flex color-selected">
              <div
                :style="{
                  height: '12px',
                  width: '12px',
                  borderRadius: '50%',
                  backgroundColor: tag.color,
                }"
              ></div>
            </div>
            <div class="wg-col wg-xs-12 wg-sm-12" @click="addTag(tag)">
              <div class="com-anm22-app-text-m" style="margin-left: 10px">
                {{ tag.label }}
              </div>
            </div>
            <div v-if="!offline" class="wg-col wg-xs-12 wg-sm-12">
              <img
                class="com-anm22-app-img-fixed-height-s"
                :src="$anm22.icons.getWorldIcon('deleteBlack')"
                style="cursor: pointer"
                @click="
                  tagToDeleteId = tag.idWorldTag;
                  deleteTagDialog = true;
                "
              />
            </div>
          </div>
        </div>
      </div>
    </wg-modal>
    <wg-modal v-if="deleteTagDialog" @closeModal="deleteTagDialog = false">
      <div class="wg-row" style="justify-content:center;" slot="body">
        <div class="com-anm22-app-text-xl">
          {{
            $anm22.strLang(
              lang,
              "Delete tag from system?",
              "Cancellare tag dal sistema?"
            )
          }}
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row" style="align-items:center;justify-content:center;">
          <input
            type="button"
            class="small com-anm22-button-blue"
            :value="$anm22.strLang(lang, 'OK', 'OK')"
            @click="deleteTag(tagToDeleteId)"
          />
          <div class="com-anm22-app-horizontal-space" style="width:20px;"></div>
          <input
            type="button"
            class="small com-anm22-button-red"
            :value="$anm22.strLang(lang, 'Cancel', 'Annulla')"
            @click="deleteTagDialog = false"
          />
        </div>
      </div>
    </wg-modal>
    <wg-modal
      v-if="openLinkModal"
      :width="windowWidth > 700 ? '700px' : '90%'"
      @closeModal="openLinkModal = false"
    >
      <div
        class="wg-row"
        slot="header"
        style="flex-wrap: nowrap; align-items: center"
      >
        <div class="com-anm22-app-text-xl" slot="header">
          {{ $anm22.strLang(lang, "Add new link", "Aggiungi link") }}
        </div>
      </div>
      <add-link :element="project" @save="saveLink" slot="body"></add-link>
    </wg-modal>
    <!-- Modale per la scelta della visualizzazione -->
    <wg-modal v-if="showViewDialog" @closeModal="showViewDialog = false">
      <div
        class="wg-row"
        slot="header"
        style="flex-wrap: nowrap; align-items: center"
      >
        <div class="com-anm22-app-text-xl" slot="header">
          {{ $anm22.strLang(lang, "View", "Visualizzazione") }}
        </div>
      </div>
      <div slot="body" class="views-list">
        <div
          :class="['item', view == 'full' ? 'selected' : '']"
          @click="changeView('full')"
        >
          <img :src="$anm22.icons.getWorldIcon('viewFull')" />
          <div>{{ $anm22.strLang(lang, "List", "Lista") }}</div>
        </div>
        <div
          :class="['item', view == 'cols' ? 'selected' : '']"
          @click="changeView('cols')"
        >
          <img :src="$anm22.icons.getWorldIcon('viewCols')" />
          <div>Kanban</div>
        </div>
        <div
          :class="['item', view == 'gantt' ? 'selected' : '']"
          @click="changeView('gantt')"
        >
          <img :src="$anm22.icons.getWorldIcon('viewGantt')" />
          <div>{{ $anm22.strLang(lang, "Workflow", "Workflow") }}</div>
        </div>
      </div>
    </wg-modal>
    <!-- <anm22-filter 
        :filters="taskFilters" 
        :showDialog="showFilterDialog" 
        @applyFilters="filterTasks($event)"
        @closeFilter="showFilterDialog = false;">
    </anm22-filter>-->
    <!-- Modale per importazione Tasks -->
    <wg-modal
      :width="windowWidth > 700 ? '700px' : '90%'"
      v-if="showImportDialog"
      @closeModal="showImportDialog = !showImportDialog"
    >
      <div class="com-anm22-app-text-xl" slot="header">
        {{ $anm22.strLang(lang, "Import tasks", "Importa task") }}
      </div>
      <div class="wg-row" slot="body" style="justify-content: center">
        <template v-if="importTemplateOnly">
          <div class="com-anm22-app-text-xl">
            {{
              $anm22.strLang(lang, "Select template", "Selezionare il template")
            }}
          </div>
          <div class="vertical-height-div" style="height: 10px"></div>
          <select class="com-anm22-app-select" v-model="importTemplate">
            <option value="" selected disabled hidden>
              {{ $anm22.strLang(lang, "Select", "Seleziona") }}
            </option>
            <option
              v-for="(project, index) in projectTemplates"
              :key="'proj-t-' + index"
              :value="project.idWorldProject"
            >
              {{
                (project.projectId !== "" ? project.projectId + "-" : "") +
                  project.name
              }}
            </option>
          </select>
        </template>
        <template v-else>
          <div class="com-anm22-app-text-xl">
            {{
              $anm22.strLang(lang, "Select project", "Selezionare il progetto")
            }}
          </div>
          <div class="vertical-height-div" style="height: 10px"></div>
          <wg-search
            v-if="!(importTemplate && importTemplate != '')"
            :placeholder="'RVT MAR ROS 25 001'"
            :url="'vircos/searchProject'"
            :clickFn="selectImportProject"
            :canAdd="false"
            :attachedData="{ projectId: project.idWorldProject }"
            :debounceTime="1000"
          ></wg-search>
          <div v-else class="selected-import-project">
            <div>{{ importProject.projectId }} {{ importProject.name }}</div>
            <img
              :src="this.$anm22.icons.getWorldIcon('deleteBlack')"
              @click="unsetImportProject"
            />
          </div>
        </template>
        <div
          v-if="
            importTemplateOnly &&
              (project.category == 1 || project.category == 2 || project.category == 10)
          "
          class="import-search-mode-btn"
          @click="importTemplateOnly = false"
        >
          {{
            $anm22.strLang(
              lang,
              "Search all projects",
              "Cerca in tutti i progetti"
            )
          }}
        </div>
        <div
          v-if="!importTemplateOnly && !importTemplate"
          class="import-search-mode-btn"
          @click="importTemplateOnly = true"
        >
          {{ $anm22.strLang(lang, "Search templates", "Cerca template") }}
        </div>
        <div class="vertical-height-div" style="height: 20px"></div>
        <div class="import-tasks-option">
          <input
            id="importTasksFlag"
            type="checkbox"
            :value="0"
            style="display:none;"
            v-model="importTasksFlag"
          />
          <label class="label-input-radio" for="importTasksFlag">{{
            importTasksFlag ? "✔" : ""
          }}</label>
          <div class="com-anm22-app-text-m input-label">
            {{ $anm22.strLang(lang, "Tasks", "Tasks") }}
          </div>
        </div>
        <div class="import-tasks-option">
          <input
            id="importTaskUsersFlag"
            type="checkbox"
            :value="0"
            style="display:none;"
            v-model="importTaskUsersFlag"
          />
          <label class="label-input-radio" for="importTaskUsersFlag">{{
            importTaskUsersFlag ? "✔" : ""
          }}</label>
          <div class="com-anm22-app-text-m input-label">
            {{ $anm22.strLang(lang, "Task user associations", "Utenti assegnati ai task") }}
          </div>
        </div>
        <template v-if="project.category == 1 || project.category == 2 || project.category == 10">
          <div class="import-tasks-option">
            <input
              id="importMeasuresFlag"
              type="checkbox"
              :value="0"
              style="display:none;"
              v-model="importMeasuresFlag"
            />
            <label class="label-input-radio" for="importMeasuresFlag">{{
              importMeasuresFlag ? "✔" : ""
            }}</label>
            <div class="com-anm22-app-text-m input-label">
              {{ $anm22.strLang(lang, "Measures", "Misure anatomiche") }}
            </div>
          </div>
          <div class="import-tasks-option">
            <input
              id="importCuttingFlag"
              type="checkbox"
              :value="0"
              style="display:none;"
              v-model="importCuttingFlag"
            />
            <label class="label-input-radio" for="importCuttingFlag">{{
              importCuttingFlag ? "✔" : ""
            }}</label>
            <div class="com-anm22-app-text-m input-label">
              {{ $anm22.strLang(lang, "Cutting", "Taglio") }}
            </div>
          </div>
          <div class="import-tasks-option">
            <input
              id="importLabFlag"
              type="checkbox"
              :value="0"
              style="display:none;"
              v-model="importLabFlag"
            />
            <label class="label-input-radio" for="importLabFlag">{{
              importLabFlag ? "✔" : ""
            }}</label>
            <div class="com-anm22-app-text-m input-label">
              {{ $anm22.strLang(lang, "Lab", "Laboratorio") }}
            </div>
          </div>
          <div class="import-tasks-option">
            <input
              id="importFinishingFlag"
              type="checkbox"
              :value="0"
              style="display:none;"
              v-model="importFinishingFlag"
            />
            <label class="label-input-radio" for="importFinishingFlag">{{
              importFinishingFlag ? "✔" : ""
            }}</label>
            <div class="com-anm22-app-text-m input-label">
              {{ $anm22.strLang(lang, "Finishing", "Finitura") }}
            </div>
          </div>
        </template>
        <div
          v-if="importTemplate"
          class="wg-row"
          style="align-items: center; justify-content: center; margin-top: 20px"
        >
          <input
            type="button"
            class="com-anm22-button-blue"
            :value="$anm22.strLang(lang, 'Import', 'Importa')"
            @click="importTasks"
          />
        </div>
      </div>
    </wg-modal>
    <!-- Modale gestione singolo Task -->
    <wg-modal
      :width="windowWidth > 700 ? (windowWidth > 1500 ? '1400px' : '80%') : '100%'"
      v-if="showTaskDialog"
      @closeModal="showTaskDialog = !showTaskDialog"
    >
      <task-title
        slot="header"
        :taskId="selectedTask"
        @closeTaskModal="showTaskDialog = !showTaskDialog"
      ></task-title>
      <task-detail slot="body" :taskId="selectedTask"></task-detail>
    </wg-modal>
    <!-- Modale ordinamento task -->
    <wg-modal
      :width="windowWidth > 700 ? '300px' : '80%'"
      v-if="changeOrderModalStatus"
      @closeModal="changeOrderModalStatus = false"
    >
      <div
        class="wg-row"
        slot="header"
        style="flex-wrap: nowrap; align-items: center"
      >
        <div class="com-anm22-app-text-xl" slot="header">
          {{ $anm22.strLang(lang, "Order", "Ordinamento") }}
        </div>
      </div>
      <div slot="body">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Order by", "Ordina per") }}
        </div>
        <div class="vertical-height-div" style="height: 5px"></div>
        <select
          class="com-anm22-app-select"
          v-model="orderingField"
          @change="changeFieldSorting()"
        >
          <option
            v-for="(f, index) in orderingFields"
            :class="[
              f.field == 'status' && f.field != orderingField ? 'none' : '',
            ]"
            :disabled="f.field == 'status'"
            :key="'field-' + index"
            :value="f.field"
          >
            {{ f.label }}
          </option>
        </select>
        <div class="vertical-height-div" style="height: 10px"></div>
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Direction", "Direzione") }}
        </div>
        <div class="vertical-height-div" style="height: 5px"></div>
        <select
          @change="changeDirectionSorting()"
          class="com-anm22-app-select"
          v-model="orderingDir"
        >
          <option value="DESC">
            {{ $anm22.strLang(lang, "Decreasing", "Decrescente") }}
          </option>
          <option value="ASC">
            {{ $anm22.strLang(lang, "Increasing", "Crescente") }}
          </option>
        </select>
      </div>
    </wg-modal>
    <wg-spinner-modal v-if="taskLoading"></wg-spinner-modal>
    <div class="wg-row">
      <!-- Titolo e tasti di visualizzazione -->
      <div class="wg-row" style="flex-wrap: nowrap; align-items: center">
        <div :class="['wg-col', windowWidth <= 992 ? 'wg-xs-11' : 'wg-xs-9']">
          <slot></slot>
        </div>
        <!-- Switch visualizzazione -->
        <div
          :class="[
            'wg-col',
            'display-flex',
            windowWidth <= 992 ? 'wg-xs-3' : 'wg-xs-3',
          ]"
          style="align-items: center; justify-content: flex-end"
        >
          <div class="change-label" @click="showViewDialog = true">
            <div class="name">
              {{
                $anm22.strLang(lang, "Change view", "Cambia visualizzazione")
              }}
            </div>
            <img
              :src="
                view === 'cols'
                  ? $anm22.icons.getWorldIcon('viewCols')
                  : view === 'full'
                  ? $anm22.icons.getWorldIcon('viewFull')
                  : $anm22.icons.getWorldIcon('viewGantt')
              "
              class="com-anm22-app-img-s img"
              style="cursor: pointer"
            />
          </div>
          <!-- <img
            :src="$anm22.icons.getWorldIcon('smartphone')"
            class="com-anm22-app-img-s"
            style="cursor:pointer;"
            @click="$emit('changeMode')"
          >-->
          <img
            v-if="windowWidth <= 992"
            :src="$anm22.icons.getWorldIcon('chat')"
            class="com-anm22-app-img-s"
            style="cursor: pointer; margin: 6px"
            @click="$emit('openBoard')"
          />
        </div>
      </div>
      <div class="vertical-height-div" style="height: 5px"></div>
      <div
        class="wg-row display-flex"
        :style="{
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
        }"
      >
        <div class="widgets-box display-flex com-anm22-app-custom-scroll">
          <!-- Componente custom dashboard tasks -->
          <template v-if="!offline">
            <paglierani-task
              v-if="isEnabledCustomComponents('paglierani/PaglieraniTask.vue')"
              :projectId="project.idWorldProject"
            ></paglierani-task>
            <spiagge-task
              v-if="isEnabledCustomComponents('spiagge/SpiaggeTask.vue')"
              :projectId="project.idWorldProject"
            ></spiagge-task>
            <vircos-tasks-widget
              v-if="isEnabledCustomComponents('vircos/VircosTasksWidget.vue')"
              :projectId="project.idWorldProject"
              @open-task="openTask"
              ref="vircosWidgets"
            ></vircos-tasks-widget>
            <ecodemolizioni-tasks-widget
              v-if="isEnabledCustomComponents('ecodemolizioni/EcodemolizioniTasksWidget.vue')"
              :projectId="project.idWorldProject"
            ></ecodemolizioni-tasks-widget>
          </template>
          <template v-if="!project.developers.includes(474)">
            <template v-if="project.links.length > 0">
              <links
                :links="project.links"
                @removeLink="deleteProjectLink"
              ></links>
            </template>
            <div
              class="display-flex link-buttons"
              style="align-items: center; flex-wrap: nowrap"
            >
              <div class="wg-row icons">
                <div class="icon-div">
                  <img
                    class="com-anm22-app-img-fixed-height-l"
                    style="padding: 5px; height: 100%"
                    :title="$anm22.strLang(lang, 'Add link', 'Aggiungi link')"
                    :src="$anm22.icons.getWorldIcon('link')"
                    @click="openLinkModal = true"
                  />
                </div>
              </div>
            </div>
          </template>
        </div>
        <template v-if="!project.developers.includes(474)">
          <div
            class="wg-xs-none wg-md- com-anm22-horizontal-space"
            style="width: 15px"
          ></div>
          <div
            class="widgets-box tags display-flex com-anm22-app-custom-scroll"
          >
            <div
              :title="$anm22.strLang(lang, 'Add tag', 'Aggiungi etichetta')"
              @click="openTagDialog()"
              class="display-flex project-tag add"
            >
              <div class="com-anm22-app-text-m" style="white-space: nowrap">
                +
              </div>
              <img
                style="margin-left: 3px"
                class="com-anm22-app-img-fixed-height-s"
                :src="$anm22.icons.getWorldIcon('tag')"
              />
            </div>
            <div
              v-for="(tag, index) in projectTags"
              :key="'tag' + index"
              class="display-flex project-tag"
            >
              <img
                v-if="!isSynchronized(tag)"
                class="com-anm22-app-img-fixed-height-m"
                :src="$anm22.icons.getWorldIcon('offline')"
                style="margin-right:5px;"
                :title="
                  $anm22.strLang(lang, 'Not synchronized', 'Non sincronizzato')
                "
              />
              <div class="color-selected">
                <div
                  :style="{
                    height: '12px',
                    width: '12px',
                    borderRadius: '50%',
                    backgroundColor: tag.color,
                  }"
                ></div>
              </div>
              <div
                class="com-anm22-app-text-m"
                style="margin-left: 10px; white-space: nowrap"
              >
                {{ tag.label }}
              </div>
              <div class="color-selected" style="margin-left: 10px">
                <img
                  class="com-anm22-app-img-fixed-height-s"
                  :src="$anm22.icons.getWorldIcon('deleteBlack')"
                  style="cursor: pointer"
                  @click="removeTag(tag)"
                />
              </div>
            </div>
          </div>
        </template>
      </div>
      <!-- Lista Task -->
      <div
        class="wg-row"
        style="align-items: center; justify-content: space-between"
      >
        <div class="com-anm22-app-text-xxl">
          {{ $anm22.strLang(lang, "Tasks", "Elenco task") }}
        </div>
        <div
          class="vertical-height-div wg-sm-none wg-md-none"
          style="height: 5px"
        ></div>
        <!-- TO-DO con dialog, no redirect -->
        <div class="display-flex" style="justify-content: flex-end">
          <input
            v-if="view === 'cols'"
            type="button"
            class="small"
            style="margin: 0 0 5px 0"
            :value="$anm22.strLang(lang, 'Order', 'Ordinamento')"
            @click="changeOrderModalStatus = true"
          />
          <input
            type="button"
            class="small"
            style="margin: 0 0 5px 10px"
            :value="$anm22.strLang(lang, 'Import', 'Importa')"
            @click="showImportDialog = true"
          />
          <input
            v-if="canAdd"
            type="button"
            class="small"
            style="margin: 0 0 5px 10px"
            :value="$anm22.strLang(lang, '+ Add Task', '+ Aggiungi Task')"
            @click="addTask"
          />
        </div>
        <!-- <div class="com-anm22-horizontal-space" style="width:10px;"></div>
        <div class="display-flex">
          <input 
            type="button" 
            class="small"
            :value="$anm22.strLang(lang, 'Filters', 'Filtri')"
            @click="showFilterDialog = true">
        </div>-->
      </div>
      <!-- Lista Tasks -->
      <div
        v-if="loading && allTasks.length === 0"
        class="wg-row"
        style="margin: 10px; justify-content: center"
      >
        <vue-simple-spinner size="medium" line-fg-color="#88ed7c" />
      </div>
      <template v-else>
        <template v-if="allTasks.length === 0">
          <div
            v-if="project.developers.includes(474)"
            class="com-anm22-app-text-xl"
          >
            {{ $anm22.strLang(lang, "No tasks", "Nessun task") }}
          </div>
          <div v-else class="com-anm22-app-text-xl" style="margin: auto">
            <img
              :src="$anm22.icons.getWorldIcon('menuTasks')"
              style="width: 200px; display: block; margin: 20px auto; opacity: 0.1"
            />
            <div
              style="
                text-align: center;
                max-width: 400px;
                font-size: 16px;
                color: #666;
                margin: 0 auto;
              "
            >
              {{ $anm22.strLang(lang, "No tasks", "Nessun task") }}
            </div>
          </div>
        </template>
        <template v-else>
          <tasks-kanban
            v-if="view === 'cols'"
            :tasksData="allTasksData"
            :sortingFunctionGenerator="getDefaultSortingFunctionGenerator"
            :boardOpen="boardOpen"
            @open-task="openTask"
            :orderingField="orderingField"
            :orderingDir="orderingDir"
          ></tasks-kanban>
          <tasks-gantt
            v-else-if="view === 'gantt'"
            :tasksData="allTasksData"
            :project="project"
            :boardOpen="boardOpen"
            @open-task="openTask"
          ></tasks-gantt>
          <tasks-list
            v-else
            :tasksData="allTasksData"
            :sortingFunctionGenerator="getDefaultSortingFunctionGenerator"
            @open-task="openTask"
          ></tasks-list>
        </template>
      </template>
      <div class="vertical-height-div" style="height: 20px"></div>
      <!-- Collegamenti rapidi ad altre sezioni dell'app -->
      <template v-if="project.developers.includes(474)">
        <div
          class="wg-row wg-xs-12 wg-sm-6 wg-md-4 wg-lg-3"
          style="padding: 0 5px"
        >
          <div
            class="com-anm22-app-white-container project-dashboard-box events"
            style="display: flex; align-items: center"
          >
            <div
              class="display-flex"
              style="align-items: center; cursor: pointer"
              @click="$emit('selectPage', 'events')"
            >
              <div class="box-img"></div>
              <div class="box-text">
                {{
                  $anm22.strLang(lang, "Project shifts", "Turni di progetto")
                }}
              </div>
            </div>
            <div v-if="canAddEvent" style="margin-left: auto; cursor: pointer">
              <!-- TO-DO link alla pagina di aggiunta evento su progetto -->
              <img
                :src="$anm22.icons.getWorldIcon('addGreen')"
                class="com-anm22-app-img-s"
                :title="
                  $anm22.strLang(
                    lang,
                    'Add project shift',
                    'Aggiungi turno al progetto'
                  )
                "
                @click="$emit('selectPage', 'events', 'addEvent')"
              />
            </div>
          </div>
        </div>
        <div
          class="wg-row wg-xs-12 wg-sm-6 wg-md-4 wg-lg-3"
          style="padding: 0 5px"
        >
          <div
            class="com-anm22-app-white-container project-dashboard-box expenses"
            style="display: flex; align-items: center"
          >
            <div
              class="display-flex"
              style="align-items: center; cursor: pointer"
              @click="$emit('selectPage', 'expenses')"
            >
              <div class="box-img"></div>
              <div class="box-text">
                {{
                  $anm22.strLang(lang, "Project expenses", "Spese di progetto")
                }}
              </div>
            </div>
            <div v-if="canAddOutgo" style="margin-left: auto; cursor: pointer">
              <!-- TO-DO link alla pagina di aggiunta spesa di progetto -->
              <img
                :src="$anm22.icons.getWorldIcon('addGreen')"
                class="com-anm22-app-img-s"
                :title="
                  $anm22.strLang(
                    lang,
                    'Add project expense',
                    'Aggiungi spesa di progetto'
                  )
                "
                @click="$emit('selectPage', 'expenses', 'addExpense')"
              />
            </div>
          </div>
        </div>
        <div
          v-if="project.status === 2"
          class="wg-row wg-xs-12 wg-sm-6 wg-md-4 wg-lg-3"
          style="padding: 0 5px"
        >
          <div
            class="com-anm22-app-white-container project-dashboard-box lock"
            style="display: flex; align-items: center"
          >
            <div
              class="display-flex"
              style="align-items: center; cursor: pointer"
              @click="lockProject"
            >
              <div class="box-img"></div>
              <div class="box-text">
                {{ $anm22.strLang(lang, "Lock project", "Blocca progetto") }}
              </div>
            </div>
          </div>
        </div>
        <template
          v-else-if="project.status === 1 || project.status === 5"
        ></template>
        <template v-else>
          <div
            v-if="
              (userPermission <= 3 || customerManager) && project.status !== 4
            "
            class="wg-row wg-xs-12 wg-sm-6 wg-md-4 wg-lg-3"
            style="padding: 0 5px"
          >
            <div
              class="com-anm22-app-white-container project-dashboard-box lock"
              style="display: flex; align-items: center"
            >
              <div
                class="display-flex"
                style="align-items: center; cursor: pointer"
                @click="unlockProject"
              >
                <div class="box-img"></div>
                <div class="box-text">
                  {{
                    $anm22.strLang(lang, "Unlock project", "Sblocca progetto")
                  }}
                </div>
              </div>
            </div>
          </div>
          <div
            v-else
            class="wg-row wg-xs-12 wg-sm-6 wg-md-4 wg-lg-3"
            style="padding: 0 5px"
          >
            <div
              class="com-anm22-app-white-container project-dashboard-box inactive locked"
              style="display: flex; align-items: center"
            >
              <div class="display-flex" style="align-items: center">
                <div class="box-img"></div>
                <div class="box-text" style="font-weight: normal">
                  {{ $anm22.strLang(lang, "Locked", "Commessa bloccata") }}
                </div>
              </div>
            </div>
          </div>
        </template>
        <div
          class="wg-row wg-xs-12 wg-sm-6 wg-md-4 wg-lg-3"
          style="padding: 0 5px"
        >
          <div
            class="com-anm22-app-white-container project-dashboard-box statistics"
            style="display: flex; align-items: center"
          >
            <div
              class="display-flex"
              style="align-items: center; cursor: pointer"
              @click="$emit('selectPage', 'statistics')"
            >
              <div class="box-img"></div>
              <div class="box-text">
                {{
                  $anm22.strLang(
                    lang,
                    "Project statistics",
                    "Statistiche di progetto"
                  )
                }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="wg-row wg-xs-12 wg-sm-6 wg-md-4 wg-lg-3"
          style="padding: 0 5px"
        >
          <div
            class="com-anm22-app-white-container project-dashboard-box change-project"
            style="display: flex; align-items: center"
          >
            <router-link to="/">
              <div
                class="display-flex"
                style="align-items: center; cursor: pointer"
              >
                <div class="box-img"></div>
                <div class="box-text">
                  {{
                    $anm22.strLang(lang, "Change project", "Cambia progetto")
                  }}
                </div>
              </div>
            </router-link>
          </div>
        </div>
        <div
          v-if="project.developers.includes(474)"
          class="wg-row wg-xs-12 wg-sm-6 wg-md-4 wg-lg-3"
          style="padding: 0 5px"
        >
          <div
            class="com-anm22-app-white-container project-dashboard-box statistics"
            style="display: flex; align-items: center"
          >
            <div class="box-img"></div>
            <div class="box-text">
              <a
                :href="
                  'https://www.anm22.it/app/tasks/projectStatisticsAdminV?idWorldProject=' +
                    project.idWorldProject
                "
                >{{
                  $anm22.strLang(lang, "Administration", "Amministrazione")
                }}</a
              >
            </div>
          </div>
        </div>
      </template>
    </div>

    <!-- Floating button per l'aggiunta -->
    <wg-fab
      :style="{ 'z-index': 20, position: 'fixed', ...fbPosition }"
      :icon="$anm22.icons.getWorldIcon('addWhite')"
      :bgColor="'#88ed7c'"
      :click="addTask"
    ></wg-fab>
  </div>
</template>

<script>
import { mapState } from "vuex";
import TasksKanban from "../components/tasks/TasksKanban.vue";
import TasksList from "../components/tasks/TasksList.vue";
import TasksGantt from "../components/tasks/TasksGantt.vue";
// import TaskBar from "../components/task/TaskBar.vue";
import TaskDetail from "../components/task/TaskDetail.vue";
import TaskTitle from "../components/task/TaskTitle.vue";
import Spinner from "vue-simple-spinner";
import Anm22DialogFilter from "../../../../world/spa/components/Anm22DialogFilter.vue";
import AddLink from "../../../../world/spa/components/WorldAddLink.vue";
import Links from "../../../../world/spa/components/WorldLinks.vue";
import PaglieraniTask from "../components/custom/paglierani/PaglieraniTask.vue";
import SpiaggeTask from "../components/custom/spiagge/SpiaggeTask.vue";
import VircosTasksWidget from "../components/custom/vircos/VircosTasksWidget.vue";
import EcodemolizioniTasksWidget from '../components/custom/ecodemolizioni/EcodemolizioniTasksWidget.vue';

export default {
  props: {
    boardOpen: Boolean,
    expBoard: Boolean,
    projectId: [Number, String],
    customerManager: [Boolean],
    action: String,
  },
  data() {
    return {
      loading: false,
      view:
        this.$anm22.getCookie("tk_t_view") !== ""
          ? this.$anm22.getCookie("tk_t_view")
          : "cols",
      // status:
      //   this.$anm22.getCookie("tk_t_status") !== ""
      //     ? this.$anm22.getCookie("tk_t_status")
      //     : "running",
      // colOrder:
      //   this.$anm22.getCookie("tk_t_col") !== ""
      //     ? this.$anm22.getCookie("tk_t_col")
      //     : "priority",
      // dirOrder: "DESC",
      taskLoading: false,
      showTaskDialog: false,
      deleteMode: false,
      deleteTagDialog: false,
      selectedTask: null,
      showFilterDialog: false,
      selectedFilters: [],
      updateInterval: null,
      /* Import da template */
      showImportDialog: false,
      importTemplate: "",
      importTemplateOnly: true,
      importTasksFlag: true,
      importTaskUsersFlag: true,
      importMeasuresFlag: false,
      importCuttingFlag: false,
      importLabFlag: false,
      importFinishingFlag: false,
      tagToDeleteId: null,
      showViewDialog: false,
      changeOrderModalStatus: false,
      orderingField:
        this.$anm22.getCookie("tk_t_col") !== ""
          ? this.$anm22.getCookie("tk_t_col")
          : "priority",
      orderingDir:
        this.$anm22.getCookie("tk_t_dir") !== ""
          ? this.$anm22.getCookie("tk_t_dir")
          : "DESC",
      openLinkModal: false,
      deleteMode: false,
      showColors: false,
      showTagDialog: false,
      newTag: {
        color: "#5291ff",
        label: "",
      },
      tagSelectFilterString: "",
      tagColors: [
        {
          name: this.$anm22.strLang(this.lang, "Gray", "Grigio"),
          color: "#999",
        },
        {
          name: this.$anm22.strLang(this.lang, "Blue", "Blu"),
          color: "#5291ff",
        },
        {
          name: this.$anm22.strLang(this.lang, "Purple", "viola"),
          color: "purple",
        },
        { name: this.$anm22.strLang(this.lang, "Red", "Rosso"), color: "red" },
        {
          name: this.$anm22.strLang(this.lang, "Orange", "Arancione"),
          color: "orange",
        },
        {
          name: this.$anm22.strLang(this.lang, "Yellow", "Giallo"),
          color: "yellow",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      lang: (state) => state.lang,
      offline: (state) => state.offline.isOffline,
      windowWidth: (state) => state.windowWidth,
    }),
    project() {
      return this.$store.getters["projects/get"](this.projectId);
    },
    userPermission() {
      return this.$store.getters["employments/getPermByProject"](this.project);
    },
    reports() {
      return this.$store.getters["employeeExpenseReports/getAll"].filter(
        (r) =>
          this.project.users.includes(r.user) &&
          this.project.developers.includes(r.work)
      );
    },
    allTasks() {
      return this.$store.getters["tasks/getByProject"](
        this.project.idWorldProject
      );
    },
    allTasksData() {
      return this.allTasks.map((t) => {
        const data = {
          id: t.idWorldTask,
          priority: t.priority,
          name: t.name,
          users: t.users,
          status: t.status,
          startDate: t.startDate,
          fts: t.fts,
          jobs: t.jobs,
          project: t.project,
          actualEndDate: t.actualEndDate,
          expectedEndDate: t.expectedEndDate,
          deadline: t.actualEndDate || t.expectedEndDate || "",
        };
        return data;
      });
    },
    licenses() {
      return this.$store.getters["employments/getByUser"](this.user.idWorldUser)
        .filter((e) => this.project.developers.includes(e.work))
        .map((e) => this.$store.getters["licenses/getByWork"](e.work))
        .filter((l) => l);
    },
    customComponents() {
      let components = [];
      this.licenses
        .filter(
          (l) =>
            l.config.tasks &&
            l.config.tasks.tasks &&
            l.config.tasks.tasks["add-to-dashboard"] !== ""
        )
        .forEach((l) => {
          const componentPath = l.config.tasks.tasks["add-to-dashboard"];
          components.push(() =>
            import("../components/custom/" + componentPath)
          );
        });
      return components;
    },
    fbPosition() {
      if (this.windowWidth >= 992) {
        if (this.boardOpen) {
          if (this.expBoard) {
            return {
              right: "calc(39% + 30px)",
              bottom: "30px",
            };
          } else {
            return {
              right: "calc(25% + 30px)",
              bottom: "30px",
            };
          }
        } else {
          return {
            right: "50px",
            bottom: "30px",
          };
        }
      } else {
        return {
          right: "30px",
          bottom: "30px",
        };
      }
    },
    canAddEvent() {
      return this.licenses
        .filter(
          (l) =>
            l.config.tasks &&
            l.config.tasks.events &&
            l.config.tasks.events["add-rules"]
        )
        .reduce(
          (result, l) =>
            result && this.$anm22[l.config.tasks.events["add-rules"]](this),
          true
        );
    },
    canAddOutgo() {
      return this.licenses
        .filter(
          (l) =>
            l.config.tasks &&
            l.config.tasks.expenses &&
            l.config.tasks.expenses["add-rules"]
        )
        .reduce(
          (result, l) =>
            result && this.$anm22[l.config.tasks.expenses["add-rules"]](this),
          true
        );
    },
    projectTemplates() {
      const templates = [],
        ids = [];
      this.project.developers.forEach((d) => {
        this.$store.getters["projects/getAllByWork"](d)
          .filter((p) => p.template)
          .forEach((p) => {
            if (!ids.includes(p.idWorldProject)) {
              ids.push(p.idWorldProject);
              templates.push(p);
            }
          });
      });
      return templates;
    },
    canAdd() {
      return this.licenses
        .filter(
          (l) =>
            l.config.tasks &&
            l.config.tasks.tasks &&
            l.config.tasks.tasks["add-rules"]
        )
        .reduce(
          (result, l) =>
            result && this.$anm22[l.config.tasks.tasks["add-rules"]](this),
          true
        );
    },
    orderingFields() {
      return [
        {
          field: "priority",
          label: this.$anm22.strLang(this.lang, "Priority", "Priorità"),
        },
        {
          field: "name",
          label: this.$anm22.strLang(this.lang, "Name", "Nome"),
        },
        {
          field: "status",
          label: this.$anm22.strLang(this.lang, "Status", "Stato"),
        },
        {
          field: "deadline",
          label: this.$anm22.strLang(this.lang, "Deadline", "Scadenza"),
        },
      ];
    },
    tags() {
      return this.$store.getters["tags/getAll"].filter((t) =>
        this.project.developers.includes(t.work)
      );
    },
    projectTags() {
      if (this.project.tags && this.project.tags.length > 0) {
        return this.project.tags
          .map((tId) => this.$store.getters["tags/get"](tId))
          .filter((t) => t && this.project.developers.includes(t.work));
      } else {
        return [];
      }
    },
    tagsToSelect() {
      return this.tags
        .filter(
          (t) =>
            -1 !== t.label.search(new RegExp(this.tagSelectFilterString, "i"))
        )
        .sort(function(a, b) {
          var propA = a.label.toUpperCase();
          var propB = b.label.toUpperCase();

          return propA.localeCompare(propB);
        });
    },
    canAddLabel() {
      if (
        this.tags.find(
          (t) => t.label.toUpperCase() == this.newTag.label.toUpperCase()
        )
      ) {
        return false;
      } else {
        return true;
      }
    },
    importProject() {
      if (this.importTemplate) {
        return this.$store.getters["projects/get"](this.importTemplate);
      } else {
        return null;
      }
    },
  },
  methods: {
    searchFn(string) {
      const regexp = new RegExp(string, "i");
      let results = [];
      /* Ricerca contatti per nome */
      this.allTasks
        .filter((t) => {
          return -1 !== t.name.search(regexp);
        })
        .map((t) => {
          return {
            label: t.name,
            img: this.getIconByStatus(t.status),
            submitFn: () => {
              this.openTask(t.idWorldTask);
            },
          };
        })
        .forEach((res) => {
          results.push(res);
        });
      return results;
    },
    openTagDialog() {
      this.showTagDialog = true;
      this.newTag.color = "#5291ff";
      this.newTag.label = "";
      this.tagSelectFilterString = "";
    },
    async deleteProjectLink(index) {
      let links = this.project.links;
      links.splice(index, 1);
      try {
        const response = await this.$http.post(
          "project/links",
          {
            projectId: this.project.idWorldProject,
            links: links,
          },
          {
            withCredentials: true,
          }
        );
        this.$store.dispatch("projects/update", {
          vlf: this.$vlf("projects"),
          objs: response.data.projects,
        });
      } catch (e) {
        await Promise.all([
          this.$store.dispatch("projects/update", {
            vlf: this.$vlf("projects"),
            objs: [this.project],
          }),
          this.$store.dispatch("offline/saveSyncTuple", {
            _vue: this,
            _class: "WorldProject",
            _table: "projects",
            mode: "edit",
            type: "obj",
            obj: this.project,
          }),
        ]);
      }
    },
    isButtonSelected(status) {
      return this.status === status;
    },
    isSynchronized(tag) {
      return this.$store.getters["offline/isSynchronized"](
        this.$anm22.MD5("WorldTag" + tag.idWorldTag)
      );
    },
    changeView(newView) {
      this.view = newView;
      this.$anm22.setCookie("tk_t_view", newView, 31536000);
      this.showViewDialog = false;
    },
    filterTasks(newFilters) {
      this.selectedFilters = newFilters;
      this.showFilterDialog = false;
    },
    getDefaultSortingFunctionGenerator(field, direction) {
      return (a, b) => {
        const deadlineOrdering = () => a.deadline - b.deadline;
        const aProp = a[field];
        const bProp = b[field];
        if (direction === "ASC") {
          if (aProp > bProp) {
            return 1;
          }
          if (aProp < bProp) {
            return -1;
          }
          if (field !== "deadline") {
            return deadlineOrdering();
          }
        } else {
          if (aProp > bProp) {
            return -1;
          }
          if (aProp < bProp) {
            return 1;
          }
          if (field !== "deadline") {
            return deadlineOrdering();
          }
        }
      };
    },
    getIconByStatus(status) {
      switch (status) {
        case 1:
          return this.$anm22.icons.getTasksIcon("tasksGrey");
        case 2:
          return this.$anm22.icons.getTasksIcon("tasksYellow");
        case 3:
          return this.$anm22.icons.getTasksIcon("tasksGreen");
        default:
          return this.$anm22.icons.getTasksIcon("tasksBlack");
      }
    },
    async addTask() {
      this.taskLoading = true;
      const task = {};
      task.idWorldTask = task.dbKey = this.$anm22.genLocalId();
      try {
        const response = await this.$http.post(
          "task/new",
          {
            projectId: this.projectId,
            syncId: task.idWorldTask,
          },
          {
            withCredentials: true,
          }
        );
        this.openTask(response.data.tasks[0].idWorldTask);
      } catch (e) {
        //Creo il nuovo task nel db locale
        task.name = "New task";
        task.project = this.project.idWorldProject;
        task.status = 1;
        task.startDate = "";
        task.expectedEndDate = "";
        task.actualEndDate = "";
        task.expectedWorkHours = 0;
        task.actualWorkHours = 0;
        task.priority = 3;
        task.users = [];
        task.fts = [];
        task.jobs = [];
        task.links = [];
        await Promise.all([
          this.$store.dispatch("tasks/update", {
            vlf: this.$vlf("tasks"),
            objs: [task],
          }),
          /* Sync update */
          this.$store.dispatch("offline/saveSyncTuple", {
            _vue: this,
            _class: "WorldTask",
            _table: "tasks",
            mode: "new",
            type: "obj",
            obj: task,
          }),
          // this.$anm22.saveSyncTuple(this, "WorldTask", "new", task)
        ]);
        this.openTask(task.idWorldTask);
      }
    },
    async openTask(id) {
      this.taskLoading = true;
      try {
        const response = await this.$http.get("task?idWorldTask=" + id);
        //aggiorno il db locale con la risposta
        await Promise.all([
          this.$store.dispatch("tasks/update", {
            vlf: this.$vlf("tasks"),
            objs: response.data.tasks,
          }),
          this.$store.dispatch("users/update", {
            vlf: this.$vlf("users"),
            objs: response.data.users,
          }),
        ]);
      } catch (e) {
      } finally {
        this.selectedTask = id;
        this.taskLoading = false;
        this.showTaskDialog = true;
        this.$Progress.finish();
      }
    },
    lockProject() {
      this.$http
        .post(
          "project/lock",
          {
            projectId: this.projectId,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.data) {
            this.project.status = response.data.projectStatus;
            return this.$store.dispatch("projects/update", {
              vlf: this.$vlf("projects"),
              objs: [this.project],
            });
          } else {
            return this.$vlf("projects").removeItem(String(this.projectId));
            this.$router.push("/");
          }
        })
        .catch((error) => {});
    },
    unlockProject() {
      this.$http
        .post(
          "project/unlock",
          {
            projectId: this.projectId,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.data) {
            this.project.status = response.data.projectStatus;
            return this.$store.dispatch("projects/update", {
              vlf: this.$vlf("projects"),
              objs: [this.project],
            });
          } else {
            return this.$vlf("projects").removeItem(String(this.projectId));
            this.$router.push("/");
          }
        })
        .catch((error) => {});
    },
    loadData() {
      Promise.all(
        ["tasks", "tags"].map((d) => {
          return this.$store.dispatch(d + "/load", this.$vlf(d));
        })
      ).then(() => {
        this.$Progress.finish();
        this.loading = false;
      });
    },
    async saveLink(links) {
      try {
        const response = await this.$http.post(
          "project/links",
          {
            projectId: this.project.idWorldProject,
            links: links,
          },
          {
            withCredentials: true,
          }
        );
        this.$store.dispatch("projects/update", {
          vlf: this.$vlf("projects"),
          objs: response.data.projects,
        });
      } catch (e) {
        this.project.links = links;
        await Promise.all([
          this.$store.dispatch("projects/update", {
            vlf: this.$vlf("projects"),
            objs: [this.project],
          }),
          this.$store.dispatch("offline/saveSyncTuple", {
            _vue: this,
            _class: "WorldProject",
            _table: "projects",
            mode: "edit",
            type: "obj",
            obj: this.project,
          }),
        ]);
      } finally {
        this.$anm22.eventBus.$emit("wg-modal-close");
      }
    },
    updateData() {
      if (!this.offline && !document.hasFocus() && !this.showTaskDialog) {
        this.$http
          .get("project/tasks?idProject=" + this.project.idWorldProject)
          .then((response) => {
            if (response.data) {
              return this.$store.dispatch("tasks/update", {
                vlf: this.$vlf("tasks"),
                objs: response.data.tasks,
                cleanFilters: [
                  (t) => {
                    return (
                      Number.isSafeInteger(t.idWorldTask) &&
                      t.project === this.project.idWorldProject
                    );
                  },
                ],
              });
            }
          })
          .catch((error) => console.log(error));
      }
    },
    importTasks() {
      if (this.importTasksFlag) {
        this.$http
          .post(
            "project/importTasks",
            {
              projectId: this.project.idWorldProject,
              importId: this.importTemplate,
              taskUsers: this.importTaskUsersFlag,
            },
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            this.$store
              .dispatch("tasks/update", {
                vlf: this.$vlf("tasks"),
                objs: response.data.tasks,
              })
              .then(() => {
                this.$anm22.eventBus.$emit("wg-modal-close");
              });
          })
          .catch((e) => console.log(error));
      }

      if (
        this.importMeasuresFlag ||
        this.importCuttingFlag ||
        this.importLabFlag ||
        this.importFinishingFlag
      ) {
        this.$http
          .post(
            "vircos/copy",
            {
              projectId: this.project.idWorldProject,
              sourceProjectId: this.importTemplate,
              measures: this.importMeasuresFlag,
              cutting: this.importMCuttingFlag,
              lab: this.importLabFlag,
              finishing: this.importFinishingFlag,
            },
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            Promise.all([
              this.$vlf("vircos-project-docs").setItem(
                String(response.data.docs.project),
                response.data.docs
              ),
            ]).then(() => {
              this.$refs.vircosWidgets.loadData();
              this.$anm22.eventBus.$emit("wg-modal-close");
            });
          })
          .catch((e) => console.log(error));
      }
    },
    selectImportProject(projectId) {
      this.importTemplate = projectId;
    },
    unsetImportProject() {
      this.importTemplate = null;
    },
    addTag(selected) {
      let tag, mode;
      if (selected) {
        tag = selected;
        mode = "select";
      } else {
        tag = this.newTag;
        mode = "new";
        tag.idWorldTag = tag.dbKey = this.$anm22.genLocalId();
      }
      this.$http
        .post(
          "project/add-tag",
          {
            projectId: this.project.idWorldProject,
            tag: tag,
            mode: mode,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          Promise.all([
            this.$store.dispatch("projects/update", {
              vlf: this.$vlf("projects"),
              objs: response.data.projects,
            }),
            this.$store.dispatch("tags/update", {
              vlf: this.$vlf("tags"),
              objs: [response.data.tag],
            }),
          ])
            .then(() => {
              this.showTagDialog = false;
              this.tagSelectFilterString = "";
            })
            .catch((error) => console.log(error));
        })
        .catch((error) => {
          this.project.tags.push(tag.idWorldTag);
          let work = null;
          let found = null;
          let developers = this.project.developers;
          let employments = this.$store.getters["employments/getByUser"](
            this.user.idWorldUser
          );
          employments.forEach((em) => {
            found = developers.find((devId) => devId == em.work);
          });
          if (found) {
            work = found;
          }
          tag.work = work;

          Promise.all([
            mode === "new"
              ? this.$store.dispatch("tags/update", {
                  vlf: this.$vlf("tags"),
                  objs: [tag],
                })
              : Promise.resolve(),
            this.$store.dispatch("projects/update", {
              vlf: this.$vlf("projects"),
              objs: [this.project],
            }),
            mode === "new"
              ? this.$store.dispatch("offline/saveSyncTuple", {
                  _vue: this,
                  _class: "WorldTag",
                  _table: "tags",
                  mode: "new",
                  type: "obj",
                  obj: tag,
                })
              : Promise.resolve(),

            this.$store.dispatch("offline/saveSyncTuple", {
              _vue: this,
              _class: "WorldProject",
              _table: "projects",
              mode: "edit",
              type: "obj",
              obj: this.project,
            }),
          ]).then(() => {
            this.showTagDialog = false;
            this.tagSelectFilterString = "";
          });
        });
    },
    removeTag(tag) {
      this.$http
        .post(
          "project/remove-tag",
          {
            projectId: this.project.idWorldProject,
            tagId: tag.idWorldTag,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.$store
            .dispatch("projects/update", {
              vlf: this.$vlf("projects"),
              objs: response.data.projects,
            })
            .catch((error) => console.log(error));
        })
        .catch((error) => {
          /* Offline */
          const index = this.project.tags.findIndex(
            (t) => t === tag.idWorldTag
          );
          if (-1 !== index) {
            this.project.tags.splice(index, 1);
            Promise.all([
              this.$store.dispatch("projects/update", {
                vlf: this.$vlf("projects"),
                objs: [this.project],
              }),
              this.$store.dispatch("offline/saveSyncTuple", {
                _vue: this,
                _class: "WorldProject",
                _table: "projects",
                mode: "edit",
                type: "obj",
                obj: this.project,
              }),
            ]);
          }
        });
    },
    // Cancellazione tag dal sistema
    deleteTag(id) {
      this.$http
        .post(
          "project/delete-tag",
          {
            idWorldTag: id,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (!response.data.error) {
            this.$store
              .dispatch("tags/delete", {
                vlf: this.$vlf("tags"),
                obj: response.data.tag,
              })
              .catch((error) => console.log(error));
          } else {
            this.showMessage();
          }
        })
        .then(() => {
          this.deleteTagDialog = false;
          this.tagToDeleteId = null;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    showMessage() {
      this.$anm22.eventBus.$emit("world-headbar-show-message", {
        text: this.$anm22.strLang(
          this.lang,
          "Unable to delete tag from system",
          "Impossibile cancellare il tag dal sistema"
        ),
        type: "alarm",
      });
    },
    getTags() {
      this.$http
        .get("project/get-tags?idProject=" + this.projectId)
        .then((response) => {
          this.$store
            .dispatch("tags/update", {
              vlf: this.$vlf("tags"),
              objs: response.data.tags,
            })
            .then(() => {})
            .catch((error) => console.log(error));
        })
        .catch((error) => console.log(error));
    },
    selectColor(color) {
      this.newTag.color = color;
      this.showColors = false;
    },
    changeFieldSorting() {
      this.$anm22.setCookie("tk_t_col", this.orderingField, 31536000);
    },
    changeDirectionSorting() {
      this.$anm22.setCookie("tk_t_dir", this.orderingDir, 31536000);
    },
    isEnabledCustomComponents(customComponentPath) {
      let isEnabled = false;
      this.licenses
        .filter(
          (l) =>
            l.config.tasks &&
            l.config.tasks.tasks &&
            l.config.tasks.tasks["add-to-dashboard"] !== ""
        )
        .forEach((l) => {
          const componentPath = l.config.tasks.tasks["add-to-dashboard"];
          if (customComponentPath == componentPath) {
            isEnabled = true;
          }
        });
      return isEnabled;
    },
  },
  created() {
    this.loading = true;
    this.loadData();
    this.getTags();
    this.$http
      .get("project/tasks?idProject=" + this.project.idWorldProject)
      .then((response) => {
        if (response.data) {
          Promise.all([
            this.$store.dispatch("tasks/update", {
              vlf: this.$vlf("tasks"),
              objs: response.data.tasks,
              cleanFilters: [
                (t) => {
                  return (
                    Number.isSafeInteger(t.idWorldTask) &&
                    t.project === this.project.idWorldProject
                  );
                },
              ],
            }),
            this.$store.dispatch("employeeExpenseReports/update", {
              vlf: this.$vlf("employeeExpenseReports"),
              objs: response.data.employeeExpenseReports,
            }),
          ]).then(() => {
            if (this.action !== "") {
              if (this.$route.query.id) {
                this[this.action](this.$route.query.id);
              } else {
                this[this.action]();
              }
            }
            this.$emit("resetAction");
            this.$store.dispatch("offline/sync", {
              _vue: this,
              blocking: true,
              callback: async (data) => {
                const update = data.success.find(
                  (d) =>
                    d.requestData.obj.idWorldProject === this.$route.params.id
                );
                if (update) {
                  this.$router.replace(
                    "/project/" + update.responseData.idWorldProject
                  );
                }
              },
            });
          });
        } else {
          /* Rimuovo tutti i task / developer associati a questo progetto dai task nello stato */
          const toRemove = this.$store.getters["tasks/getByProject"](
            this.project.idWorldProject
          );
          this.$store.dispatch("tasks/deleteMultiple", toRemove).then(() => {
            this.$router.push("/");
          });
        }
      })
      .catch((error) => console.log(error));
  },
  mounted() {
    this.$anm22.eventBus.$emit("world-headbar-search-config", {
      hintFn: this.searchFn,
    });
    this.$nextTick(() => {
      this.updateInterval = setInterval(() => {
        this.updateData();
      }, 30000);
    });
  },
  destroyed() {
    this.$anm22.eventBus.$emit("world-headbar-search-config", null);
    clearInterval(this.updateInterval);
  },
  components: {
    TasksList,
    TasksKanban,
    TasksGantt,
    // TaskBar,
    TaskDetail,
    TaskTitle,
    "vue-simple-spinner": Spinner,
    Anm22DialogFilter,
    AddLink,
    Links,
    PaglieraniTask,
    SpiaggeTask,
    VircosTasksWidget,
    EcodemolizioniTasksWidget,
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../world/libs/anm22_web_graphics/v1/scss/_variables.scss";

.cols-labels {
  padding: 10px 0;
}
.change-label {
  padding: 6px;
  font-size: 14px;
  cursor: pointer;
  border: 1px solid #666;
  color: #666;
  border-radius: 4px;
}
.change-label .name {
  font-size: 15px;
  color: #666;
  display: inline-block;
  vertical-align: middle;
}
.change-label .img {
  display: inline-block;
  vertical-align: middle;
  margin-left: 3px;
}
@media screen and (max-width: 992px) {
  .change-label .name {
    display: none;
  }
  .change-label .img {
    margin: auto;
  }
}
.views-list {
  text-align: center;

  .item {
    text-align: center;
    display: inline-block;
    vertical-align: top;
    width: 150px;
    margin: 5px;
    border-radius: 6px;
    cursor: pointer;
    padding: 10px 0 15px 0;

    img {
      display: inline-block;
      height: 60px;
      opacity: 0.6;
    }
    div {
      text-align: center;
      display: block;
      font-size: 16px;
    }
  }
  .item:hover,
  .item.selected {
    background: #eee;
  }
}
.link-buttons .icons {
  align-items: center;
  font-size: 0;
  padding: 5px 0 0 0;
}
.icon-div {
  border-radius: 30px;
  width: 60px;
  border: 1px solid #9999;
  height: 60px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 40px 40px;
  padding: 10px;
  margin: 5px 10px;
  cursor: pointer;
  &:hover {
    border: none;
    background-color: #eee;
  }
}
.widgets-box {
  flex-wrap: nowrap;
  align-items: center;
  overflow-x: auto;
  max-width: 100%;
  //white-space: nowrap;
  margin-bottom: 10px;
}
// .widgets-box > div {
//   display: inline-block;
//   vertical-align: middle;
// }
.add-tag-btn {
  padding: 4px;
  min-width: 80px;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  background-color: #ddd;
}
.project-tag {
  align-items: center;
  flex-wrap: nowrap;
  background-color: #ddd;
  font-size: 14px;
  padding: 10px;
  border-radius: 10px;
  margin: 5px 10px 5px 0;
  cursor: pointer;

  &.add:hover {
    background-color: #ccc;
  }
}
.color-select {
  min-width: 50px;
  height: 36px;
  border: 1px solid #bbb;
  border-radius: 4px;
  position: relative;
  cursor: pointer;
}
.color-list {
  flex-wrap: nowrap;
  background-color: #fff;
  position: absolute;
  top: 36px;
  z-index: 20;
  border: 1px solid #ddd;
  box-shadow: 0px 1px 5px #666;
  & > div {
    height: 36px;
    width: 50px;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    &:hover {
      background-color: #eee;
    }
    & > div {
      cursor: pointer;
      height: 12px;
      width: 12px;
      border-radius: 50%;
    }
  }
}
.tags-list {
  margin-top: 10px;
  min-height: 200px;
  height: 200px;
  border: 1px solid #bbb;
  border-radius: 4px;
  padding: 5px;
}
.tag-select {
  flex-wrap: nowrap;
  align-items: center;
  height: 36px;
  cursor: pointer;
  padding: 5px;
  &:hover {
    background-color: #eee;
  }
}
.color-selected {
  height: 100%;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: center;
  white-space: nowrap;
}
.selected-import-project {
  div {
    display: inline-block;
    vertical-align: middle;
  }
  img {
    height: 16px;
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
    margin-left: 10px;
  }
}
.import-search-mode-btn {
  text-align: center;
  display: block;
  width: 100%;
  box-sizing: border-box;
  padding: 4px 8px;
  cursor: pointer;
}
.import-tasks-option {
  text-align: center;
  display: block;
  width: 100%;
  box-sizing: border-box;
  padding: 4px 8px;

  .label-input-radio {
    display: inline-block;
    vertical-align: middle;
    height: 20px;
    width: 20px;
    border: 1px solid #bbb;
    border-radius: 4px;
    font-size: 16px;
    padding: 1px 2px;
    cursor: pointer;
    margin-right: 10px;
  }

  .input-label {
    display: inline-block;
    vertical-align: middle;
  }
}
</style>
